module.exports = __webpack_public_path__ + "static/media/new.8245ebf2.png";